import { arrayUnion, arrayRemove } from "firebase/firestore";
import { updateUser } from ".";

/**
 * Mueve una historia a la lista de archivadas del usuario.
 * @param {string} storyId - ID de la historia a agregar.
 * @returns {Promise<object>} Datos actualizados del usuario.
 */
export const moveToArchive = (storyId) => {
  if (!storyId) return;

  return updateUser({
    archivedIds: arrayUnion(storyId),
    favorites: arrayRemove(storyId),
    storyIds: arrayRemove(storyId),
  });
};

/**
 * Desarchiva una historia del usuario.
 * @param {string} storyId - ID de la historia a desarchivar.
 * @returns {Promise<object>} Datos actualizados del usuario.
 */
export const unarchiveStory = (storyId) => {
  if (!storyId) return;

  return updateUser({
    archivedStoryIds: arrayRemove(storyId),
    storyIds: arrayUnion(storyId),
  });
};
